import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, take } from 'rxjs/operators';
import { AuthState } from '../../features/auth/auth.state';

export const adminGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    const store = inject(Store);
    const router = inject(Router);

    const returnUrl = '/' + segments.map(s => s.path).join('/');
    const status = store.selectSnapshot(AuthState.sessionStatus);

    if (status !== 'unknown') {
        const isLogin = store.selectSnapshot(AuthState.isLogin);
        const isAdmin = store.selectSnapshot(AuthState.isAdmin);
        if (!isLogin) {
            return router.createUrlTree(['/auth/login'], {
                queryParams: { returnUrl },
            });
        }
        if (!isAdmin) {
            return router.createUrlTree(['/home']);
        }
        return true;
    }

    return store.select(AuthState.sessionStatus).pipe(
        filter((s) => s !== 'unknown'),
        take(1),
        map(() => {
            const isLogin = store.selectSnapshot(AuthState.isLogin);
            const isAdmin = store.selectSnapshot(AuthState.isAdmin);
            if (!isLogin) {
                return router.createUrlTree(['/auth/login'], {
                    queryParams: { returnUrl },
                });
            }
            if (!isAdmin) {
                return router.createUrlTree(['/home']);
            }
            return true;
        })
    );
};